import React from 'react';
import './Partnership.css';

// Import the new image
import eventImage from '../../assets/images/partnership-event.jpg';

const Partnership = () => {
  return (
    <section className="partnership-section">
      <div className="partnership-container">
        {/* Left Column: Text Content */}
        <div className="partnership-text-col">
          <div className="section-header">
            <h2>About the partnership</h2>
            <div className="header-line"></div>
          </div>
          <p>
            Consulting is a joint venture between CRISHI and Quesrow Research & Strategy Co., created to bring strategic clarity to businesses operating in commodity-centric, policy-sensitive, and volatile markets.
          </p>
          <p>
            With capabilities spanning from granular demand planning to macroeconomic analysis, our solutions help businesses respond to change, scale with confidence, and future-proof their strategy.
          </p>
        </div>

        {/* Right Column: Image */}
        <div className="partnership-image-col">
          <img src={eventImage} alt="CRISHI and Quesrow partnership launch event" />
        </div>
      </div>
    </section>
  );
};

export default Partnership;